<div class="tw-min-w-fit tw-min-h-fit tw-pr-6 tw-pb-10 sm:tw-pr-32 sm:tw-pb-32">
    <div touchZoom stepConfig="rooms.zoom_factor" [enabled]="!isEditMode" class="room-boundary" >
        <ng-content></ng-content>
    </div>
</div>
@if(isEditMode){
    <div [cdkDragLockAxis]="'x'" [class]="'tw-absolute tw-z-10 tw-cursor-col-resize right-dragger tw-top-0'" cdkDrag (cdkDragEnded)="onDragEnd($event,'x')" [cdkDragFreeDragPosition]="cdkDragFreeDragPositionX"></div>
    <div [cdkDragLockAxis]="'y'" [class]="'tw-absolute tw-z-10 tw-cursor-row-resize bottom-dragger'" cdkDrag (cdkDragEnded)="onDragEnd($event,'y')" [cdkDragFreeDragPosition]="cdkDragFreeDragPositionY"></div>
}
